export enum NotificationType {
	SUCCESS,
	ERROR,
	WARNING
}
